// extracted by mini-css-extract-plugin
export default {"button":"RetexAction_button__uUjyC","alertModal":"RetexAction_alertModal__CiiBw","alertDescription":"RetexAction_alertDescription__joZND"};